/**
 * represents various search states for account lookup
 */
export enum SearchState {
  Initial,
  InProgress,
  Completed,
  Error,
}
